import React from 'react';
import { Field } from 'formik';
import Bone from '@lightspeed/cirrus-bone';
import Card, { CardSection } from '@lightspeed/cirrus-card';
import Checkbox from '@lightspeed/cirrus-checkbox';
import { IconWarning } from '@lightspeed/flame/Icon/Warning';

import { LayoutSection } from 'cirrus/Layout';

const Skeleton = () =>
  Array(24)
    .fill('')
    .map((_, index) => (
      // eslint-disable-next-line react/no-array-index-key
      <li key={index} className="cr-pv-2 cr-ph-1">
        <Bone width="80%" />
      </li>
    ));

const Industries = ({ isLoading, industries }) => {
  const hasIndustries = !!(industries && industries.length);

  return (
    <LayoutSection
      title="Vendor Catalogs"
      description="Add industry specific vendors to your account so you can search and import prefilled catalog items directly to your inventory."
      extra={
        <a
          href="https://www.lightspeedhq.com/pos/retail/catalogs"
          target="_blank"
          rel="noopener noreferrer"
        >
          View list of catalogs by industry
        </a>
      }
    >
      <Card>
        <CardSection>
          <ul
            className="cr-p-0 cr-m-0"
            data-test={`${isLoading || !hasIndustries ? 'no-' : ''}industries-list`}
            style={{
              listStyle: 'none',
              columnWidth: isLoading || hasIndustries ? '200px' : 'initial',
            }}
          >
            {(() => {
              if (isLoading) return <Skeleton />;
              if (!hasIndustries) {
                return (
                  <li className="cr-text-center cr-p-10">
                    <div className="cr-pb-2">
                      <IconWarning size="2rem" color="gray-300" />
                    </div>
                    <div>No industries available</div>
                  </li>
                );
              }

              return industries.map(({ id, name }) => (
                <li key={id} className="cr-pv-2 cr-ph-1">
                  <Field
                    name={id}
                    render={({ field }) => (
                      <div>
                        <Checkbox
                          label={name}
                          name={id}
                          data-test={`${id}-${name}`}
                          checked={field.value}
                          onChange={field.onChange}
                        />
                      </div>
                    )}
                  />
                </li>
              ));
            })()}
          </ul>
        </CardSection>
      </Card>
    </LayoutSection>
  );
};

export default Industries;
